<template>
  <v-card class="rsl-fixed-height">
    <v-btn
      small
      class="mr-3 float-right mt-2"
      color="error"
      @click="promoteTemplates()"
      :disabled="allHqConns.length == 0"
    >{{ $t('TEMPLATES.BTNS.PROMOTE') }}</v-btn>
    <v-tabs v-model="tab">
      <v-tab @click="refreshTemplates">
        {{ $t('TEMPLATES.TABS.DOCS') }}
      </v-tab>
      <v-tab @click="refreshTemplates">
        {{ $t('TEMPLATES.TABS.EMAILS') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  <!-- Document Templates -->
                  <v-text-field
                    v-model="searchDocs"
                    append-icon="mdi-magnify"
                    :label="$t('TEMPLATES.SEARCH_DOC_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="newTemplate('document')"
                  >{{ $t('TEMPLATES.BTNS.NEW_DOC') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="docHeaders"
                  :items="allDocTemplates"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchDocs"
                  class="elevation-1 doc-template"
                  item-key="ID"
                  :sort-by="docSortBy"
                  :sort-desc="docSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loading"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="success"
                      @click="editTemplate(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteTemplate(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  <!-- Email Templates -->
                  <v-text-field
                    v-model="searchEmails"
                    append-icon="mdi-magnify"
                    :label="$t('TEMPLATES.SEARCH_EMAIL_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="newTemplate('email')"
                  >{{ $t('TEMPLATES.BTNS.NEW_EMAIL') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="emailHeaders"
                  :items="allEmailTemplates"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchEmails"
                  class="elevation-1 email-template"
                  item-key="ID"
                  :sort-by="emailSortBy"
                  :sort-desc="emailSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loading"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="success"
                      @click="editTemplate(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteTemplate(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="deleteTemplateDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTemplateTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteTemplateText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteTemplateDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDeleteTemplate({templateId})"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteTemplatesDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteTemplatesTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ promoteTemplatesText }}</div>
            <v-data-table
              v-model="templatePromote"
              :headers="promoteHeaders"
              :items="allTemplates"
              :items-per-page="10"
              class="mx-3 mb-3"
              item-key="ID"
              sort-by="ID"
              :sort-desc="true"
              show-select
              loading-text="Loading... Please wait"
              :loading="loading"
            >
            </v-data-table>
            <v-form v-model="isFormValid" ref="promoteTemplate">
              <v-select
                v-model="selectedExternalEngine"
                label="Remote Engine"
                :items="allHqConns"
                item-text="ENGINE_NAME"
                item-value="URL"
                :rules="[rules.required]"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelPromote()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmPromoteTemplates()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteCheckDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteCheckTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ promoteCheckText }}</div>
            <div class="pt-5" v-html="promoteCheckText2"></div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              class="mr-2"
              color="secondary"
              @click="promoteCheckCancel"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="promoteOverwrite > 0 && promoteCount > 0"
              small
              class="mr-2"
              color="warning"
              @click="promoteCheckConfirm"
            >{{ $t('PROMOTE.BTNS.NO_OVERWITE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="promoteOverwrite > 0"
              small
              class="mr-2"
              color="error"
              @click="promoteCheckOverwrite"
            >{{ $t('PROMOTE.BTNS.OVERWRITE') }}</v-btn>
            <v-btn
              v-if="promoteOverwrite == 0 && promoteCount > 0"
              small
              class="mr-2"
              color="success"
              @click="promoteCheckConfirm"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteResultsDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteResultsTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5" v-html="promoteResultsText"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="promoteResultsDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  export default {
    name: 'templates',
    computed: {
      ...mapGetters(['allDocTemplates', 'allEmailTemplates', 'lastTab', 'allHqConns', 'promoteTemplateData', 'promoteTemplateRes'])
    },
    data: function() {
      return {
        loading: false,
        isFormValid: false,
        rules: {
          required: value => !!value || 'Required'
        },
        tab: null,
        deleteTemplateDialog: false,
        deleteTemplateTitle: '',
        deleteTemplateText: '',
        searchDocs: '',
        searchEmails: '',
        templateId: '',
        docSortBy: '',
        docSortDesc: false,
        emailSortBy: '',
        emailSortDesc: false,
        theTemplateName: '',
        theTemplateType: '',
        docHeaders: [
          {
            text: this.$t('TEMPLATES.FIELDS.ID'),
            align: 'start',
            sortable: true,
            value: 'ID',
          },
          { text: this.$t('TEMPLATES.FIELDS.NAME'), value: 'NAME', sortable: true },
          { text: this.$t('TEMPLATES.FIELDS.KEY'), value: 'TEMP_KEY', sortable: true },
          { text: this.$t('TEMPLATES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        emailHeaders: [
          {
            text: this.$t('TEMPLATES.FIELDS.ID'),
            align: 'start',
            sortable: true,
            value: 'ID',
          },
          { text: this.$t('TEMPLATES.FIELDS.NAME'), value: 'NAME', sortable: true },
          { text: this.$t('TEMPLATES.FIELDS.KEY'), value: 'TEMP_KEY', sortable: true },
          { text: this.$t('TEMPLATES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        allTemplates: [],
        promoteTemplatesDialog: false,
        promoteTemplatesTitle: '',
        promoteTemplatesText: '',
        promoteCheckDialog: false,
        promoteCheckTitle: '',
        promoteCheckText: '',
        promoteCheckText2: '',
        promoteCount: 0,
        promoteOverwrite: 0,
        promoteResultsDialog: false,
        promoteResultsTitle: '',
        promoteResultsText: '',
        templatePromote: [],
        selectedExternalEngine: '',
        promoteHeaders: [
          { text: this.$t('TEMPLATES.FIELDS.ID'), align: 'start', value: 'ID' },
          { text: this.$t('TEMPLATES.FIELDS.NAME'), value: 'NAME' },
          { text: this.$t('TEMPLATES.FIELDS.TYPE'), value: 'TYPE', sortable: true }
        ]
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'PROMOTE_TEMPLATE_DATA') {
          this.promoteCount = 0;
          this.promoteOverwrite = 0;
          let html = '';
          let templateExists = false;
          
          for(let i = 0; i < this.templatePromote.length; i++) {
            templateExists = false;
            for(let j = 0; j < this.promoteTemplateData.length; j++) {
              if(this.templatePromote[i].TEMP_KEY == this.promoteTemplateData[j].TEMP_KEY) {
                templateExists = true;
                if(this.promoteTemplateData[j].IS_LOCKED) {
                  html += '<p class="red--text font-weight-bold">' + this.$t('TEMPLATES.PROMOTE.TEMPLATE') + ' <em>' + this.templatePromote[i].NAME + '</em> ' + this.$t('TEMPLATES.PROMOTE.LOCKED') + '</p>';
                }else {
                  this.promoteOverwrite++;
                  html += '<p class="orange--text font-weight-bold">' + this.$t('TEMPLATES.PROMOTE.TEMPLATE') + ' <em>' + this.templatePromote[i].NAME + '</em> ' + this.$t('TEMPLATES.PROMOTE.EXISTS') + '</p>';
                }
              }
            }

            if(!templateExists) {
              this.promoteCount++;
              html += '<p class="green--text font-weight-bold">' + this.$t('TEMPLATES.PROMOTE.TEMPLATE') + ' <em>' + this.templatePromote[i].NAME + '</em> ' + this.$t('TEMPLATES.PROMOTE.CREATED') + '</p>';
            }
          }

          if(this.templatePromote.length == 0) {
            html = '<p>' + this.$t('TEMPLATES.PROMOTE.NONE') + '</p>';
          }

          this.promoteCheckTitle = this.$t('TEMPLATES.PROMOTE.CHECK_TITLE');
          this.promoteCheckText = this.$t('TEMPLATES.PROMOTE.CHECK_DESC');
          this.promoteCheckText2 = html;
          this.promoteCheckDialog = true;
        }

        if(mutation.type === 'PROMOTE_TEMPLATE_RES') {
          let html = '';
          let templateNames = [];

          for(let i = 0; i < this.promoteTemplateRes.length; i++) {
            const templateKeys = Object.keys(this.promoteTemplateRes[i]);
    
            templateKeys.forEach((key) => {
              if(this.promoteTemplateRes[i][key] == 'insert') {
                html += '<p>' + this.$t('TEMPLATES.PROMOTE.TEMPLATE') + ' ' + key + ' ' + this.$t('TEMPLATES.PROMOTE.INSERT_SUCCESS') + '</p>';
              }
              if(this.promoteTemplateRes[i][key] == 'update') {
                html += '<p>' + this.$t('TEMPLATES.PROMOTE.TEMPLATE') + ' ' + key + ' ' + this.$t('TEMPLATES.PROMOTE.UPDATE_SUCCESS') + '</p>';
              }
              templateNames.push(key);
            });
          }

          if(templateNames.length > 0) {
            this.updateLog('Templates', 'Promoted', 'Templates ' + templateNames.toString() + ' promoted to ' + this.selectedExternalEngine + '.');
          }

          this.promoteResultsTitle = this.$t('TEMPLATES.PROMOTE.RESULT_TITLE');
          this.promoteResultsText = html;
          this.promoteResultsDialog = true;
          this.$refs.promoteTemplate.reset();
          this.templatePromote = [];
        }

      });
      this.$store.dispatch('getAllHqConnections');
      this.refreshTemplates();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      refreshTemplates () {
        this.tab = this.lastTab;
        this.loading = true;
        this.$store.dispatch('getAllTemplates').then( () => {
          this.loading = false;
          // Apply sort field and order
          let docField = this.$store.state.docTemplateSortField;
          let docSort = this.$store.state.docTemplateSortOrder;
          let emailField = this.$store.state.emailTemplateSortField;
          let emailSort = this.$store.state.emailTemplateSortOrder;
          if(docField == null) {
            this.docSortBy = 'ID';
            this.docSortDesc = false;
          }else if (docSort == 'none') {
            this.docSortBy = '';
            this.docSortDesc = false;
          }else {
            this.docSortBy = docField;

            if(docSort == 'descending') {
              this.docSortDesc = true;
            }else {
              this.docSortDesc = false;
            }
          }
          if(emailField == null) {
            this.emailSortBy = 'ID';
            this.emailSortDesc = false;
          }else if (emailSort == 'none') {
            this.emailSortBy = '';
            this.emailSortDesc = false;
          }else {
            this.emailSortBy = emailField;

            if(emailSort == 'descending') {
              this.emailSortDesc = true;
            }else {
              this.emailSortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let closest = $(this).closest('.v-data-table');
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            if(closest.hasClass('doc-template')) {
              for(let i = 0; i < ref.docHeaders.length; i++) {
                if(column == ref.docHeaders[i].text) {
                  ref.$store.commit('setDocTemplateSortField', ref.docHeaders[i].value);
                  ref.$store.commit('setDocTemplateSortOrder', order);
                }
              }
            }
            // Use same click event for email templates
            if(closest.hasClass('email-template')) {
              for(let i = 0; i < ref.emailHeaders.length; i++) {
                if(column == ref.emailHeaders[i].text) {
                  ref.$store.commit('setEmailTemplateSortField', ref.emailHeaders[i].value);
                  ref.$store.commit('setEmailTemplateSortOrder', order);
                }
              }
            }
          });
        });
      },
      newTemplate(type) {
        this.$store.commit('UPDATE_TEMPLATE_ID', '');
        this.$store.commit('UPDATE_TEMPLATE_NAME', '');
        this.$store.commit('UPDATE_TEMPLATE_KEY', '');
        this.$store.commit('UPDATE_TEMPLATE_TYPE', type);
        this.$store.commit('UPDATE_TEMPLATE_ACTION', 'new');
        this.$store.commit('UPDATE_LAST_TAB', this.tab);
        this.$router.push({ name: 'TemplateEditor' });
      },
      editTemplate(item) {
        this.$store.commit('UPDATE_TEMPLATE_ID', item.ID);
        this.$store.commit('UPDATE_TEMPLATE_NAME', item.NAME);
        this.$store.commit('UPDATE_TEMPLATE_KEY', item.TEMP_KEY);
        this.$store.commit('UPDATE_TEMPLATE_TYPE', item.TYPE);
        this.$store.commit('UPDATE_TEMPLATE_ACTION', 'edit');
        this.$store.commit('UPDATE_LAST_TAB', this.tab);
        this.$router.push({ name: 'TemplateEditor' });
      },
      deleteTemplate(item) {
        this.deleteTemplateTitle = this.$t('TEMPLATES.DELETE_TEMPLATE.TITLE');
        this.deleteTemplateText = this.$t('TEMPLATES.DELETE_TEMPLATE.DESC') + ' ' + item.NAME;
        this.templateId = item.ID;
        this.theTemplateName = item.NAME;
        this.theTemplateType = item.TYPE;
        this.deleteTemplateDialog = true;
      },
      confirmDeleteTemplate(item) {
        this.deleteTemplateDialog = false;

        this.$store.dispatch('deleteTemplate', item.templateId).then( () => {
          let tempType = '';
          if(this.theTemplateType == 'document') {
            tempType = 'Document';
          }
          if(this.theTemplateType == 'email') {
            tempType = 'Email';
          }
          this.updateLog('Template', 'Deleted', tempType + ' template ' + this.theTemplateName + ' deleted.');
          
          this.templateId = '';
          this.refreshTemplates();
        });
      },
      cancelPromote() {
        this.promoteTemplatesDialog = false;
        this.$refs.promoteTemplate.reset();
        this.templatePromote = [];
      },
      promoteTemplates() {
        this.promoteTemplatesTitle = this.$t('TEMPLATES.PROMOTE.TITLE');
        this.promoteTemplatesText = this.$t('TEMPLATES.PROMOTE.DESC');
        this.allTemplates = this.allDocTemplates.concat(this.allEmailTemplates);
        this.promoteTemplatesDialog = true;
      },
      confirmPromoteTemplates() {
        this.promoteTemplatesDialog = false;
        let promotePayload = [];
        let templateNames = [];

        for(let i = 0; i < this.templatePromote.length; i++) {
          promotePayload.push({ templateName: this.templatePromote[i].NAME, templateKey: this.templatePromote[i].TEMP_KEY, templateId: this.templatePromote[i].ID });
          templateNames.push(this.templatePromote[i].NAME);
        }
        
        let payload = {
          promotes: JSON.stringify(promotePayload),
          engine: this.selectedExternalEngine
        };
        
        this.$store.dispatch('promoteTemplatesCheck', payload);
      },
      promoteCheckCancel() {
        this.promoteCheckDialog = false;
        this.$refs.promoteTemplate.reset();
        this.templatePromote = [];
      },
      promoteCheckConfirm() {
        this.promoteCheckDialog = false;
        
        for(let i = 0; i < this.templatePromote.length; i++) {
          for(let j = 0; j < this.promoteTemplateData.length; j++) {
            if(this.templatePromote[i].TEMP_KEY == this.promoteTemplateData[j].TEMP_KEY) {
              this.templatePromote.splice(i, 1);
            }
          }
        }
        
        let payload = {
          promotes: JSON.stringify(this.templatePromote),
          engine: this.selectedExternalEngine
        };
        
        this.$store.dispatch('promoteTemplates', payload);
      },
      promoteCheckOverwrite() {
        this.promoteCheckDialog = false;
        
        for(let i = 0; i < this.templatePromote.length; i++) {
          for(let j = 0; j < this.promoteTemplateData.length; j++) {
            if(this.templatePromote[i].TEMP_KEY == this.promoteTemplateData[j].TEMP_KEY) {
              if(this.promoteTemplateData[j].IS_LOCKED) {
                this.templatePromote.splice(i, 1);
              }
            }
          }
        }

        let payload = {
          promotes: JSON.stringify(this.templatePromote),
          engine: this.selectedExternalEngine
        };
        
        this.$store.dispatch('promoteTemplates', payload);
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>